import {
    all,
    any,
    equals,
    isEmpty,
    isNil,
    pick,
    pipe,
    trim,
    values
} from "ramda"

const alphabetsAndWhiteSpaceRegex = new RegExp(/[^a-zA-Z\d, ]/);
const numeberWithTwoDecimalRegex = /^\d{0,}(\.\d{0,2})?$/;
const isProperDecimal = /^\d{1,}(\.\d{1,2})?$/;
const numberRegex = new RegExp(/\d+/);

export const isNotValidEmail = (email: string) =>
    RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email);

const convertString = (value: any) => String(value);

export const isEmptyString = pipe(convertString, trim, isEmpty);

export const isNotValidFormObject = (formValue: object) => {
    return any(isEmptyString)(values(formValue));
};
export const isNotValidFormObjectForSpecificKeys = (
    formValue: object,
    keys: string[]
): boolean => {
    //@ts-ignore
    return isNotValidFormObject(pick(keys, formValue));
};

export const checkForErrorObject = (errorFormValue: object) =>
    all(equals(false))(values(errorFormValue));

export const isValidNumber = (value: string) => {
    if (isEmptyString(value) && !equals(0, value.length)) {
        return false;
    } else if (!+value && !equals(+value, 0)) {
        return false;
    } else {
        return true;
    }
};

export const isValidCvv = (value: string) => {
    return value.length > 2 && value.length <= 4;
};
export const isValidPostal = (value: string) => {
    return value.length > 2 && !isEmptyString(trim(value));
};

export const isValidText = (value: string) => {
    var alphabetsAndWhiteSpaceRegex = new RegExp(/[^a-zA-Z, ]/);
    return !numberRegex.test(value) && !alphabetsAndWhiteSpaceRegex.test(value);
};

export const isNotEmpty = (value: any) => !isEmpty(value) && !isNil(value);

export const isNotSpecialCharcter = (value: string) =>
    !alphabetsAndWhiteSpaceRegex.test(value);

export const isDecimalNumberWithTwoDigits = (value: string) => {
    return numeberWithTwoDecimalRegex.test(value);
};
export const isValidDecimalNumber = (value: string) => {
    return isProperDecimal.test(value);
};

export const validDecimalValueWithZero = (value: string) => {
    const isValueLessThanOne = Number(value) > 0 && Number(value) < 1;
    const splittedValue = value.split(".");

    const splittedValueEmpty = splittedValue[0] === "";

    const updatedValue = Number(splittedValue[0]) + "." + splittedValue[1];

    // const isValueZero = Number(value) === 0;

    // if(value === '.'){
    //     return '.'
    // }

    // if (isValueZero) {
    //     return "0";
    // }

    if (isValueLessThanOne) {
        if (splittedValueEmpty) {
            return "0" + trim(value);
        } else {
            return trim(updatedValue);
        }
    }
    return value;
};

export const isValidPercentage = (value: string) => {
    return Number(value) > 100;
};

export const checkValidPositiveNumber = (value: string) => {
    return value === "" || Number(value) <= 0;
};

export const checkisValidValue = (value: any) => {
    if (value === null || value === undefined || value.length === 0) {
        return "NA";
    } else {
        return value;
    }
};

export const ConvertToNum = (val: string) => {
    let value = val.replace(/[^.\d]/g, "");
    if (Number(parseInt(value))) {
        if (Number(value) >= 0 && Number(value) <= 100) {
            return value;
        } else {
            return;
        }
    } else {
        return value;
    }
};
